export default "__VITE_ASSET__CTQPpfQG__"